import { render, staticRenderFns } from "./SingleType.vue?vue&type=template&id=48b9e84c&"
import script from "./SingleType.vue?vue&type=script&lang=js&"
export * from "./SingleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports